import { useState, useRef, useEffect } from "react";
import Swal from "sweetalert2";

export default function JobsPortalBootstrap() {
  const [fileName, setFileName] = useState("");
  const [fileError, setFileError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const phoneInputRef = useRef(null);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = [".pdf", ".doc", ".docx"];
      const fileExt = "." + file.name.split(".").pop().toLowerCase();
      const maxSize = 10 * 1024 * 1024; // 10MB

      if (!validTypes.includes(fileExt)) {
        setFileError("Please upload a PDF, DOC, or DOCX file");
        setFileName("");
        e.target.value = "";
        return;
      }

      if (file.size > maxSize) {
        setFileError("File size must be less than 10MB");
        setFileName("");
        e.target.value = "";
        return;
      }

      setFileName(file.name);
      setFileError("");
    }
  };

  const setLoading = (loading) => {
    setIsLoading(loading);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setLoading(true);

    try {
      const form = e.target;
      const formData = new FormData(form);

      // Get phone number details from intl-tel-input
      if (phoneInputRef.current) {
        formData.append('phone', phone);
        formData.append("country_name", countryData.name);
      }

      const response = await fetch("https://us-central1-backend-metbrains.cloudfunctions.net/api/api/job/job-application/submit", {
        method: "POST",
        body: formData
      });

      if (response.ok) {
        const data = await response.json();

      } else {
        throw new Error('Submission failed');
      }
    } catch (err) {
      console.log(err);
      // Reset loading state on error
      setLoading(false);
      
      // Use SweetAlert2 for error message
      if (Swal) {
        Swal.fire({
          title: "Error!",
          text: "There was an error submitting your application. Please try again.",
          icon: "error",
        });
      } else {
        alert("There was an error submitting your application. Please try again.");
      }
    }
  };

  const [phone, setPhone] = useState(null);
  const [countryData, setCountryData] = useState(null);

  const handlePhoneChange = (value, countryData) => {
    setPhone(value);
    setCountryData(countryData);
  };

  return (
    <>
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css"
        rel="stylesheet"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/css/intlTelInput.css"
      />
      <style>{`
        a {
          text-decoration: none;
        }
        
        .gradient-header {
          background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);
          position: relative;
          overflow: hidden;
        }
        
        .gradient-circle-1 {
          position: absolute;
          top: -100px;
          right: -100px;
          width: 200px;
          height: 200px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
        }
        
        .gradient-circle-2 {
          position: absolute;
          bottom: -75px;
          left: -75px;
          width: 150px;
          height: 150px;
          background: rgba(59, 130, 246, 0.2);
          border-radius: 50%;
        }
        
        .gradient-button {
          background: linear-gradient(135deg, #0ea5e9 0%, #3b82f6 100%);
          border: none;
          transition: transform 0.2s;
        }
        
        .gradient-button:hover:not(:disabled) {
          transform: scale(1.05);
        }
        
        .gradient-button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #0ea5e9;
          box-shadow: 0 0 0 0.25rem rgba(14, 165, 233, 0.25);
        }
        
        .form-check-input:checked {
          background-color: #0ea5e9;
          border-color: #0ea5e9;
        }
        
        .form-check-input:focus {
          box-shadow: 0 0 0 0.25rem rgba(14, 165, 233, 0.25);
        }
        
        .text-purple {
          color: #0ea5e9;
        }
        
        .text-purple:hover {
          color: #0284c7;
        }
        
        .bg-purple-light {
          background-color: #e0f2fe;
        }
        
        .icon-wrapper {
          width: 48px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .icon-wrapper svg {
          width: 24px;
          height: 24px;
          stroke: #0ea5e9;
        }
        
        .radio-card {
          cursor: pointer;
          transition: all 0.2s;
          position: relative;
        }
        
        .radio-card:hover {
          border-color: #0ea5e9 !important;
        }
        
        .radio-card input:checked ~ .card-body {
          background-color: #e0f2fe;
        }
        
        .upload-area {
          border: 2px dashed #dee2e6;
          transition: border-color 0.2s;
        }
        
        .upload-area:hover {
          border-color: #0ea5e9;
        }

        .submit-loader {
          display: inline-block;
          width: 20px;
          height: 20px;
          border: 2px solid #ffffff;
          border-radius: 50%;
          border-top-color: transparent;
          animation: spin 1s ease-in-out infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .opacity-0 {
          opacity: 0;
        }

        .hidden {
          display: none !important;
        }
      `}</style>

      <article className="py-5" style={{ minHeight: "100vh" }}>
        <div className="container">
          <div
            className="mx-auto shadow-lg rounded-4 overflow-hidden bg-white"
            style={{ maxWidth: "900px" }}
          >
            {/* Header */}
            <div className="gradient-header text-white p-5">
              <div style={{ position: "relative", zIndex: 10 }}>
                <h3 className="display-6 fw-bold mb-2">
                  Career Application Form
                </h3>
                <p className="mb-0" style={{ color: "#dbeafe" }}>
                  Take the next step in your career journey with us
                </p>
              </div>
              <div className="gradient-circle-1"></div>
              <div className="gradient-circle-2"></div>
            </div>

            <div className="p-4 p-md-5">
              <form id="contact-form-hirist-2" onSubmit={handleSubmit}>
                {/* Personal Information */}
                <div className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="icon-wrapper bg-purple-light rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="h5 mb-1">Personal Information</h4>
                      <p className="text-muted small mb-0">
                        Please provide your contact details
                      </p>
                    </div>
                  </div>

                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Full Name <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-white">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                          </svg>
                        </span>
                        <input
                          type="text"
                          name="name"
                          required
                          className="form-control"
                          placeholder="Enter your full name"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <label className="form-label fw-medium">
                        Email Address <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <span className="input-group-text bg-white">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                            />
                          </svg>
                        </span>
                        <input
                          type="email"
                          name="email"
                          required
                          className="form-control"
                          placeholder="Enter your email address"
                        />
                      </div>
                    </div>

                    <div className="col-12">
                      <label className="form-label fw-medium">
                        Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        ref={phoneInputRef}
                        id="phone-tc-hirist"
                        type="tel"
                        name="phone"
                        className="form-control"
                        placeholder="Enter your phone number"
                        required
                        onChange={handlePhoneChange}
                      />
                    </div>
                  </div>
                </div>

                {/* Jobs & Preferences */}
                <div className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="icon-wrapper bg-purple-light rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="h5 mb-1">Jobs & Preferences</h4>
                      <p className="text-muted small mb-0">
                        Tell us about your career interests
                      </p>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Field of Interest <span className="text-danger">*</span>
                    </label>
                    <select name="field_looking" className="form-select" required>
                      <option value="">Select your field of interest</option>
                      <option value="Data Science">Data Science</option>
                      <option value="Data Analytics">Data Analytics</option>
                      <option value="Business Analytics">
                        Business Analytics
                      </option>
                      <option value="Digital Marketing">Digital Marketing</option>
                      <option value="Cyber Security">Cyber Security</option>
                      <option value="Data Engineering">Data Engineering</option>
                      <option value="DevOps Engineering">
                        DevOps Engineering
                      </option>
                      <option value="Project Management">
                        Project Management
                      </option>
                      <option value="Business Risk Management">
                        Business Risk Management
                      </option>
                      <option value="Financial Analytics">
                        Financial Analytics
                      </option>
                      <option value="Data Statistics & Predictive Modelling">
                        Data Statistics & Predictive Modelling
                      </option>
                      <option value="Cloud Computing">Cloud Computing</option>
                      <option value="Product Management">
                        Product Management
                      </option>
                      <option value="Big Data & ETL Pipelines">
                        Big Data & ETL Pipelines
                      </option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Experience Level <span className="text-danger">*</span>
                    </label>
                    <select name="experience_level" className="form-select" required>
                      <option value="">Select your experience level</option>
                      <option value="Fresher_Entry_Level">
                        Fresher / Entry Level (0-2 Years)
                      </option>
                      <option value="Mid_Senior_Level">
                        Mid Senior Level (2-5 Years)
                      </option>
                      <option value="Senior_Managerial_Level">
                        Senior Level (5-12 Years)
                      </option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium mb-3">
                      Employment Status <span className="text-danger">*</span>
                    </label>
                    <div className="row g-3">
                      <div className="col-sm-6">
                        <div className="card radio-card border-2">
                          <input
                            type="radio"
                            name="employment_status"
                            value="Employed_Full_Time"
                            className="form-check-input position-absolute top-0 end-0 m-3"
                            id="employed"
                            required
                          />
                          <label
                            className="card-body"
                            htmlFor="employed"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="fw-medium">Employed Full Time</div>
                            <small className="text-muted">
                              Currently working
                            </small>
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="card radio-card border-2">
                          <input
                            type="radio"
                            name="employment_status"
                            value="Open_To_Work"
                            className="form-check-input position-absolute top-0 end-0 m-3"
                            id="opentowork"
                            required
                          />
                          <label
                            className="card-body"
                            htmlFor="opentowork"
                            style={{ cursor: "pointer" }}
                          >
                            <div className="fw-medium">Open to Work</div>
                            <small className="text-muted">
                              Seeking opportunities
                            </small>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium mb-3">
                      Internship Preferences{" "}
                      <span className="text-danger">*</span>
                    </label>
                    <div className="row g-3">
                      <div className="col-sm-6">
                        <div className="card border-2">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                              <label className="small mb-0">
                                Looking for paid internships?
                              </label>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    name="looking_for_internship"
                                    value="Yes"
                                    className="form-check-input"
                                    id="paid-yes"
                                    required
                                  />
                                  <label
                                    className="form-check-label small"
                                    htmlFor="paid-yes"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    name="looking_for_internship"
                                    value="No"
                                    className="form-check-input"
                                    id="paid-no"
                                    required
                                  />
                                  <label
                                    className="form-check-label small"
                                    htmlFor="paid-no"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="card border-2">
                          <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                              <label className="small mb-0">
                                Open to unpaid internships?
                              </label>
                              <div className="d-flex gap-3">
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    name="open_to_unpaid"
                                    value="Yes"
                                    className="form-check-input"
                                    id="unpaid-yes"
                                    required
                                  />
                                  <label
                                    className="form-check-label small"
                                    htmlFor="unpaid-yes"
                                  >
                                    Yes
                                  </label>
                                </div>
                                <div className="form-check">
                                  <input
                                    type="radio"
                                    name="open_to_unpaid"
                                    value="No"
                                    className="form-check-input"
                                    id="unpaid-no"
                                    required
                                  />
                                  <label
                                    className="form-check-label small"
                                    htmlFor="unpaid-no"
                                  >
                                    No
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Skills & Documents */}
                <div className="mb-5">
                  <div className="d-flex align-items-center mb-4">
                    <div className="icon-wrapper bg-purple-light rounded me-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h4 className="h5 mb-1">Skills & Documents</h4>
                      <p className="text-muted small mb-0">
                        Tell us about your qualifications
                      </p>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Certifications & Courses
                    </label>
                    <textarea
                      name="certifications_done"
                      placeholder="Please list your relevant certifications and courses"
                      rows="4"
                      className="form-control"
                    ></textarea>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-medium">
                      Resume Upload <span className="text-danger">*</span>
                    </label>
                    <div className="upload-area rounded-3 p-5 text-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="48"
                        height="48"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                        className="text-muted mx-auto mb-3"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        />
                      </svg>
                      <div className="mb-2">
                        <label
                          htmlFor="resume-upload"
                          className="text-purple fw-medium"
                          style={{ cursor: "pointer" }}
                        >
                          Upload a file
                        </label>
                        <span className="text-muted"> or drag and drop</span>
                        <input
                          id="resume-upload"
                          name="resume"
                          type="file"
                          className="d-none"
                          accept=".pdf,.doc,.docx"
                          onChange={handleFileChange}
                          required
                        />
                      </div>
                      <p className="text-muted small mb-0">
                        PDF, DOC, DOCX up to 10MB
                      </p>
                      {fileName && (
                        <div id="selected-file-name" className="mt-2">
                          <span className="text-purple fw-medium small file-name">
                            Selected file: {fileName}
                          </span>
                        </div>
                      )}
                      {fileError && (
                        <div id="file-error-message" className="text-danger fw-medium small mt-2">
                          {fileError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Consent */}
                <div className="mb-4">
                  <div className="form-check">
                    <input
                      id="consent"
                      name="consent"
                      type="checkbox"
                      className="form-check-input"
                      required
                    />
                    <label
                      className="form-check-label small text-muted"
                      htmlFor="consent"
                    >
                      By submitting this form, I agree to HireShire's{" "}
                      <a href="#" className="text-purple text-decoration-none">
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a href="#" className="text-purple text-decoration-none">
                        Terms of Service
                      </a>
                      .
                    </label>
                  </div>
                </div>

                {/* Submit */}
                <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3">
                  <p className="text-muted small mb-0 order-2 order-sm-1">
                    All fields marked with <span className="text-danger">*</span>{" "}
                    are required
                  </p>
                  <button
                    type="submit"
                    id="submit-application"
                    className="btn gradient-button text-white fw-semibold px-4 py-2 order-1 order-sm-2"
                    disabled={isLoading}
                  >
                    <span className="submit-text" style={isLoading ? { opacity: 0 } : {}}>
                      Submit Application
                    </span>
                    {isLoading && (
                      <div className="submit-loader position-absolute"></div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </article>
    </>
  );
}